import React, { Component } from 'react';
import { Radio } from 'antd';

import AvisInformacioAddicionalMonitoritzacioLlamps from './avisInformacioAddicionalMonitoritzacioLlamps';
import AvisInformacioAddicionalMonitoritzacioMeteosat from './avisInformacioAddicionalMonitoritzacioMeteosat';
import AvisInformacioAddicionalMonitoritzacioRadar from './avisInformacioAddicionalMonitoritzacioRadar';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

const OPCIO_PER_DEFECTE = 1;

class AvisInformacioAddicionalMonitoritzacio extends Component {

    constructor(props) {
        super(props);
        this.state = { opcioSeleccionada: OPCIO_PER_DEFECTE };
    }

    seleccionarOpcio(opcio) {
        this.setState({ opcioSeleccionada: opcio });
    }

    renderOpcioSeleccionada(opcioSeleccionada) {
        switch (opcioSeleccionada) {
            case 1:
                return <AvisInformacioAddicionalMonitoritzacioLlamps />;
            case 2:
                return <AvisInformacioAddicionalMonitoritzacioMeteosat />;
            case 3:
                return <AvisInformacioAddicionalMonitoritzacioRadar />;
            default:
                return <div>Opció no implementada</div>;
        }
    }

    render() {
        const { opcioSeleccionada } = this.state;
        return (
            <div className='avis-informacio-addicional-monitoritzacio'>
                <div className='avis-informacio-addicional-monitoritzacio-menu'>
                    <Radio.Group
                        onChange={(event) => this.seleccionarOpcio(event.target.value)}
                        value={this.state.opcioSeleccionada}>
                        <Radio.Button value={1}>Llamps</Radio.Button>
                        <Radio.Button value={2}>Satèl·lit Meteosat</Radio.Button>
                        <Radio.Button value={3}>Radar</Radio.Button>
                    </Radio.Group>
                </div>
                {this.renderOpcioSeleccionada(opcioSeleccionada)}
            </div>
        );
    }
}

export default errorBoundaryWrapper(AvisInformacioAddicionalMonitoritzacio);


// WEBPACK FOOTER //
// ./src/components/avis/avisInformacioAddicionalMonitoritzacio.js